import React from 'react';
import { 
  SiShopify, 
  SiGoogle, 
  SiMeta, 
  SiFigma, 
  SiWordpress, 
  SiLaravel 
} from 'react-icons/si';

const TrustBar = () => {
  const brands = [
    { name: 'Shopify', icon: <SiShopify className="text-2xl" /> },
    { name: 'Google', icon: <SiGoogle className="text-xl" /> },
    { name: 'Meta', icon: <SiMeta className="text-2xl" /> },
    { name: 'Figma', icon: <SiFigma className="text-xl" /> },
    { name: 'WordPress', icon: <SiWordpress className="text-2xl" /> },
    { name: 'Laravel', icon: <SiLaravel className="text-2xl" /> },
  ];

  return (
    <div className="bg-white border-b border-slate-100 py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        
        {/* Label */}
        <p className="text-[11px] font-bold uppercase tracking-[0.25em] text-slate-400 mb-6">
          TRUSTED BY AMBITIOUS BUSINESSES
        </p>

        {/* Logos Grid */}
        <div className="flex flex-wrap items-center justify-center gap-8 sm:gap-12 md:gap-16 lg:gap-20 text-slate-400">
          {brands.map((brand, idx) => (
            <div 
              key={idx}
              className="flex items-center gap-2 hover:text-slate-700 transition-colors duration-200 select-none group cursor-default"
            >
              <span className="text-slate-400 group-hover:text-slate-700 transition-colors">
                {brand.icon}
              </span>
              <span className="text-base sm:text-lg font-bold tracking-tight text-slate-400 group-hover:text-slate-700 transition-colors">
                {brand.name}
              </span>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default TrustBar;
